export const translations = {
    "EN": {
        "View Bus Reservation": "View Bus Reservation",
        "Save BGR": "Save",
        "Edit Passenger": "Edit Passenger",
        "Error saving reservation": "Error saving reservation",
        "Reservation saved successfully": "Reservation saved successfully",
        "Add at least one passenger.": "Add at least one passenger.",
        "Transport Company is required": "Transport Company is required",
        "License Plate is required": "License Plate is required",
        "Required fields missing": "Required fields missing",
        "A reservation cannot have more than 20 passengers.": "A reservation cannot have more than 20 passengers.",
        "Paste MRZ here...": "Paste MRZ here...",
        "Previous": "Previous",
        "Page": "Page",
        "of": "of",
        "Next": "Next",
        "Add": "Add",
        "MRZ": "MRZ",
        "Total Records": "Total Records",
        "Manual": "Manual",
        "Save Changes BGR": "Save",
        "Save as Draft": "Save as Draft",
        "Submit BGR": "Submit",
        "Create Bus Reservation": "Create Bus Reservation",
        "Edit Bus Reservation": "Edit Bus Reservation",
        "Reservation Details": "Reservation Details",
        "PCS Reservation": "PCS Reservation",
        "Passenger/Vehicle Manifest": "Passenger Details:",
        "Type": "Type",
        "Action": "Action",
        "Remove": "Remove",
        "No manifest details added": "No manifest details added",
        "Add New Entry": "Add",
        "Name": "Name",
        "Passport Number": "Passport Number",
        "Passport Expiry Date": "Passport Expiry Date",
        "Reservation ID": "Reservation ID",
        "License Plate": "License Plate",
        "Transport Company": "Transport Company",
        "Select Company": "Select Company",
        "Status": "Status",
        "Select Status": "Select Status",
        "Travel Date": "Travel Date & Time",
        "Creation Date": "Creation Date & Time",
        "Search BGR": "Search BGR",
        "Create BGR": "Create BGR",
        "View": "View",
        "Edit": "Edit",
        "Edit (1 Time)": "Edit (1 Time)",
        "Submit": "Submit",
        "Unsubmit": "Unsubmit",
        "Close": "Close",
        "Export": "Export",
        "Reject": "Reject",
        "No BGR Lists Found": "No Bus Group Reservation Lists Found",
        "Actions": "Actions",
        "Bus Reservations": "Bus Reservations",
        "Go Back": "Go Back",
        "Print": "Print",
        "Print Thermal Ticket": "Print Thermal Ticket",
        "Change Printer": "Change Printer",
        "Printer Settings": "Printer Settings",
        "Select a printer": "Select a printer",
        "Save Changes": "Save Changes",
        "Print Test": "Print Test",
        "Print Boarding Card": "Print Boarding Card",
        "Download Boarding Card Pdf": "Download Boarding Card Pdf",
        "Download": "Download",
        "Cancelled": "Cancelled",
        "All": "All",
        "Confirmation": "Confirmation",
        "Boarding": "Boarding",
        'Cannot issue boarding pass. Confirmation status is "C"': 'Cannot issue boarding pass. Confirmation status is "C"',
        "Cannot issue boarding pass for an already printed ticket": "Cannot issue boarding pass for an already printed ticket",
        "You have successfully deleted this reservation.": "You have successfully deleted this reservation.",
        "You have successfully locked the selected trip.": "You have successfully locked the selected trip.",
        "You have successfully cancelled your boarding passes.": "You have successfully cancelled your boarding passes.",
        "Confirmation Passes Error": "There has been an error while issuing your confirmation passes. Please contact TMPA Support.",
        "You have successfully changed the trip of your tickets.": "You have successfully changed the trip for your tickets.",
        "Invalid Surname / Plates": "Invalid Surname / Plates",
        "Confirm Ticket Error": "There has been an error while confirming your tickets.",
        "You have successfully cancelled your tickets.": "You have successfully cancelled your tickets.",
        "You have successfully confirmed your tickets.": "You have successfully confirmed your tickets.",
        "Your Confirmation Passes have been issued.": "Your Confirmation Passes have been issued.",
        "Your Boarding Passes have been issued.": "Your Boarding Passes have been issued.",
        "Confirm Open Tickets": "Confirm Open Tickets",
        "Confirm Open Tickets And Issue Boarding Cards": "Confirm Open Tickets And Issue Boarding Cards",
        "Cancel": "Cancel",
        "Change Trip": "Change Trip",
        "Boarding Passes Error": "There has been an error while issuing your boarding passes. Please contact TMPA Support.",
        "Boarding Passes Issued": "Your Boarding Passes have been issued.",
        "No Data": "There are no reservation data for your search.",
        "Please type in or select a company": "Please type in or select a company",
        "Please type in the reservation number": "Please type in the reservation number",
        "Please type in a ticket number.": "Please type in a ticket or reservation number.",
        "Please select an itinerary.": "Please select an itinerary.",
        "Network Error": "Network Error. Please try again.",
        "Email Address": "Email Address",
        "Phone Number": "Phone Number",
        "Old Password": "Old Password",
        "New Password": "New Password",
        "Confirm New Password": "Confirm New Password",
        "Change Password": "Change Password",
        "Home": "Home",
        "Edit Ticket": "Edit Ticket",
        "Plate Number": " Plate Number",
        "Passport / Plates": "Passport / Plates",
        "Tanger Port Authority": "Tanger Port Authority",
        "User Id": "User Group:",
        "User Name": "User Name:",
        "User": "User",
        "Password": "Password:",
        "To": "To",
        "Login": "Login",
        "Logout": "Logout",
        "Signup": "Signup",
        "Language": "Language:",
        "English": "EN",
        "Spanish": "ES",
        "French": "FR",
        "Greek": "GR",
        "Date": "Date",
        "Company": "Company",
        "Filter by:": "Filter Itineraries by Company:",
        "Select Itinerary": "Select Itinerary",
        "Select Tickets": "Select Tickets",
        "Vessel": "Vessel",
        "Arrival Port": "Arrival Port",
        "Departure": "Departure",
        "Time": "Time",
        "Arrival": "Arrival",
        "Departure Date": "Departure Date",
        "Search for Reservation or Ticket by:": "Search for Reservation or Ticket by:",
        "PNR": "Reservation Number",
        "Surname": "Surname",
        "E-mail": "E-mail",
        "Search Reservation": "Search Reservation",
        "Ticket Number": "Ticket Number",
        "Surname Name": "Passenger Name",
        "Passenger Type": "Passenger Type",
        "Nationality": "Nationality",
        "Accomodation": "Accomodation",
        "Age/Cat Gender": "Age/Cat Gender",
        "Birth Date - Place": "Birth Date - Place",
        "Passport": "Passport",
        "Not Supported": "Not Supported",
        "Select Language": "Select Language",
        "No itinerary found for the selected date": "No itinerary found for the selected date",
        "Itinerary search": "Itinerary search",
        "Departure Itinerary": "Departure itinerary",
        "Return Itinerary": "Return itinerary",
        "Route analysis": "Route analysis",
        "Events": "Events",
        "Event": "Event",
        "Visit Event Site": "Visit Event Site",
        "Contact us": "Contact us",
        "Terms of use": "Terms of use",
        "Follow us": "Follow us",
        "No return trip selected": "No return trip selected",
        "No trips found": "No trips found for this date. Please select another date.",
        "Select": "Select",
        "Issue Boarding Cards": "Issue Boarding Cards",
        "Manual Entry": "Manual Entry",
        "Passenger": "Passenger",
        "Vehicle": "Vehicle",
        "Search Ticket": "Search Ticket",
        "firstName": "Name",
        "Maiden Name": "Maiden Name",
        "Age/Cat": "Age/Cat",
        "Adult": "Adult",
        "Child": "Child",
        "Infant": "Infant",
        "Gender": "Gender",
        "Male": "Male",
        "Female": "Female",
        "Birth Date": "Birth Date",
        "Birth Place": "Birth Place",
        "Occupation": "Occupation",
        "Coming From": "Coming From",
        "Going To": "Going To",
        "Residence Country": "Residence Country",
        "Address in Morocco": "Address in Morocco",
        "Phone During Stay": "Phone During Stay",
        "Visit Reason": "Visit Reason",
        "Accomodation Type": "Accomodation Type",
        "Cabin/Seat Number": "Cabin/Seat Number",
        "Berth": "Berth",
        "Special Service Req.": "Special Service Req.",
        "Document Type": "Document Type",
        "Travel Doc. Number": "Travel Doc. Number",
        "Travel Doc. Issue Date": "Travel Doc. Issue Date",
        "Visa Number": "Visa Number",
        "Identity ID": "Identity ID",
        "Dni": "Dni",
        "Special Passport": "Special Passport",
        "UN Travel Document": "UN Travel Document",
        "YES": "YES",
        "NO": "NO",
        "GENP": "GENP",
        "Vehicle Type": "Vehicle Type",
        "General Veh": "General Veh",
        "Registration Plates": "Registration Plates",
        "Driver Name": "Driver Name",
        "Length (cm)": "Length (cm)",
        "Height (cm)": "Height (cm)",
        "Connect Serial Device": "Connect Serial Device",
        "Model": "Model",
        "Brand": "Brand",
        "Plates": "Plates",
        "Length/Height": "Length/Height",
        "Issue Date": "Issue Date",
        "Expiration Date": "Expiration Date",
        "MRZ scanning is required. Please parse MRZ for the selected passengers.": "MRZ scanning is required. Please parse MRZ for the selected passengers."
    },
    "ES": {
        "Error saving reservation": "Error saving reservation",
        "Reservation saved successfully": "Reservation saved successfully",
        "Add at least one passenger.": "Add at least one passenger.",
        "Transport Company is required": "Transport Company is required",
        "License Plate is required": "License Plate is required",
        "Required fields missing": "Required fields missing",
        "A reservation cannot have more than 20 passengers.": "A reservation cannot have more than 20 passengers.",
        "Paste MRZ here...": "Paste MRZ here...",
        "Previous": "Previous",
        "Page": "Page",
        "of": "of",
        "Next": "Next",
        "Add": "Add",
        "MRZ": "MRZ",
        "Total Records": "Total Records",
        "Manual": "Manual",
        "Save Changes BGR": "Save",
        "Save as Draft": "Save as Draft",
        "Submit BGR": "Submit",
        "Create Bus Reservation": "Create Bus Reservation",
        "Edit Bus Reservation": "Edit Bus Reservation",
        "Reservation Details": "Reservation Details",
        "PCS Reservation": "PCS Reservation",
        "Passenger/Vehicle Manifest": "Passenger Details:",
        "Type": "Type",
        "Action": "Action",
        "Remove": "Remove",
        "No manifest details added": "No manifest details added",
        "Add New Entry": "Add",
        "Name": "Name",
        "Passport Number": "Passport Number",
        "Passport Expiry Date": "Passport Expiry Date",
        "Reservation ID": "Reservation ID",
        "License Plate": "License Plate",
        "Transport Company": "Transport Company",
        "Select Company": "Select Company",
        "Status": "Status",
        "Select Status": "Select Status",
        "Travel Date": "Travel Date & Time",
        "Creation Date": "Creation Date & Time",
        "Search BGR": "Search BGR",
        "Create BGR": "Create BGR",
        "View": "View",
        "Edit": "Edit",
        "Edit (1 Time)": "Edit (1 Time)",
        "Submit": "Submit",
        "Unsubmit": "Unsubmit",
        "Close": "Close",
        "Export": "Export",
        "Reject": "Reject",
        "No BGR Lists Found": "No Bus Group Reservation Lists Found",
        "Actions": "Actions",
        "Bus Reservations": "Bus Reservations",
        "Go Back": "Go Back",
        "Print": "Print",
        "Print Thermal Ticket": "Print Thermal Ticket",
        "Change Printer": "Change Printer",
        "Printer Settings": "Printer Settings",
        "Select a printer": "Select a printer",
        "Save Changes": "Save Changes",
        "Print Test": "Print Test",
        "Print Boarding Card": "Print Boarding Card",
        "Download Boarding Card Pdf": "Download Boarding Card Pdf",
        "Download": "Download",
        "Cancelled": "Cancelled",
        "All": "All",
        "Confirmation": "Confirmation",
        "Boarding": "Boarding",
        'Cannot issue boarding pass. Confirmation status is "C"': 'Cannot issue boarding pass. Confirmation status is "C"',
        "Cannot issue boarding pass for an already printed ticket": "Cannot issue boarding pass for an already printed ticket",
        "You have successfully deleted this reservation.": "You have successfully deleted this reservation.",
        "You have successfully locked the selected trip.": "You have successfully locked the selected trip.",
        "You have successfully cancelled your boarding passes.": "You have successfully cancelled your boarding passes.",
        "Confirmation Passes Error": "There has been an error while issuing your confirmation passes. Please contact TMPA Support.",
        "You have successfully changed the trip of your tickets.": "You have successfully changed the trip for your tickets.",
        "Invalid Surname / Plates": "Invalid Surname / Plates",
        "Confirm Ticket Error": "There has been an error while confirming your tickets.",
        "You have successfully cancelled your tickets.": "You have successfully cancelled your tickets.",
        "You have successfully confirmed your tickets.": "You have successfully confirmed your tickets.",
        "Your Confirmation Passes have been issued.": "Your Confirmation Passes have been issued.",
        "Your Boarding Passes have been issued.": "Your Boarding Passes have been issued.",
        "Confirm Open Tickets": "Confirm Open Tickets",
        "Confirm Open Tickets And Issue Boarding Cards": "Confirm Open Tickets And Issue Boarding Cards",
        "Cancel": "Cancel",
        "Change Trip": "Change Trip",
        "Boarding Passes Error": "There has been an error while issuing your boarding passes. Please contact TMPA Support.",
        "Boarding Passes Issued": "Your Boarding Passes have been issued.",
        "No Data": "There are no reservation data for your search.",
        "Please type in or select a company": "Please type in or select a company",
        "Please type in the reservation number": "Please type in the reservation number",
        "Please type in a ticket number.": "Please type in a ticket or reservation number.",
        "Please select an itinerary.": "Please select an itinerary.",
        "Network Error": "Network Error. Please try again.",
        "Email Address": "Email Address",
        "Phone Number": "Phone Number",
        "Old Password": "Old Password",
        "New Password": "New Password",
        "Confirm New Password": "Confirm New Password",
        "Change Password": "Change Password",
        "Home": "Home",
        "Edit Ticket": "Edit Ticket",
        "Plate Number": " Plate Number",
        "Passport / Plates": "Passport / Plates",
        "Tanger Port Authority": "Tanger Port Authority",
        "User Id": "User Group:",
        "User Name": "User Name:",
        "User": "User",
        "Password": "Password:",
        "To": "To",
        "Login": "Login",
        "Logout": "Logout",
        "Signup": "Signup",
        "Language": "Language:",
        "English": "EN",
        "Spanish": "ES",
        "French": "FR",
        "Greek": "GR",
        "Date": "Date",
        "Company": "Company",
        "Filter by:": "Filter Itineraries by Company:",
        "Select Itinerary": "Select Itinerary",
        "Select Tickets": "Select Tickets",
        "Vessel": "Vessel",
        "Arrival Port": "Arrival Port",
        "Departure": "Departure",
        "Time": "Time",
        "Arrival": "Arrival",
        "Departure Date": "Departure Date",
        "Search for Reservation or Ticket by:": "Search for Reservation or Ticket by:",
        "PNR": "Reservation Number",
        "Surname": "Surname",
        "E-mail": "E-mail",
        "Search Reservation": "Search Reservation",
        "Ticket Number": "Ticket Number",
        "Surname Name": "Passenger Name",
        "Passenger Type": "Passenger Type",
        "Nationality": "Nationality",
        "Accomodation": "Accomodation",
        "Age/Cat Gender": "Age/Cat Gender",
        "Birth Date - Place": "Birth Date - Place",
        "Passport": "Passport",
        "Not Supported": "Not Supported",
        "Select Language": "Select Language",
        "No itinerary found for the selected date": "No itinerary found for the selected date",
        "Itinerary search": "Itinerary search",
        "Departure Itinerary": "Departure itinerary",
        "Return Itinerary": "Return itinerary",
        "Route analysis": "Route analysis",
        "Events": "Events",
        "Event": "Event",
        "Visit Event Site": "Visit Event Site",
        "Contact us": "Contact us",
        "Terms of use": "Terms of use",
        "Follow us": "Follow us",
        "No return trip selected": "No return trip selected",
        "No trips found": "No trips found for this date. Please select another date.",
        "Select": "Select",
        "Issue Boarding Cards": "Issue Boarding Cards",
        "Manual Entry": "Manual Entry",
        "Passenger": "Passenger",
        "Vehicle": "Vehicle",
        "Search Ticket": "Search Ticket",
        "firstName": "Name",
        "Maiden Name": "Maiden Name",
        "Age/Cat": "Age/Cat",
        "Adult": "Adult",
        "Child": "Child",
        "Infant": "Infant",
        "Gender": "Gender",
        "Male": "Male",
        "Female": "Female",
        "Birth Date": "Birth Date",
        "Birth Place": "Birth Place",
        "Occupation": "Occupation",
        "Coming From": "Coming From",
        "Going To": "Going To",
        "Residence Country": "Residence Country",
        "Address in Morocco": "Address in Morocco",
        "Phone During Stay": "Phone During Stay",
        "Visit Reason": "Visit Reason",
        "Accomodation Type": "Accomodation Type",
        "Cabin/Seat Number": "Cabin/Seat Number",
        "Berth": "Berth",
        "Special Service Req.": "Special Service Req.",
        "Document Type": "Document Type",
        "Travel Doc. Number": "Travel Doc. Number",
        "Travel Doc. Issue Date": "Travel Doc. Issue Date",
        "Visa Number": "Visa Number",
        "Identity ID": "Identity ID",
        "Dni": "Dni",
        "Special Passport": "Special Passport",
        "UN Travel Document": "UN Travel Document",
        "YES": "YES",
        "NO": "NO",
        "GENP": "GENP",
        "Vehicle Type": "Vehicle Type",
        "General Veh": "General Veh",
        "Registration Plates": "Registration Plates",
        "Driver Name": "Driver Name",
        "Length (cm)": "Length (cm)",
        "Height (cm)": "Height (cm)",
        "Connect Serial Device": "Connect Serial Device",
        "Model": "Model",
        "Brand": "Brand",
        "Plates": "Plates",
        "Length/Height": "Length/Height",
        "Issue Date": "Issue Date",
        "Expiration Date": "Expiration Date",
        "MRZ scanning is required. Please parse MRZ for the selected passengers.": "Se requiere escanear el MRZ. Por favor, escanee el MRZ de los pasajeros seleccionados."
    },
    "FR": {
        "Error saving reservation": "Error saving reservation",
        "Reservation saved successfully": "Reservation saved successfully",
        "Add at least one passenger.": "Add at least one passenger.",
        "Transport Company is required": "Transport Company is required",
        "License Plate is required": "License Plate is required",
        "Required fields missing": "Required fields missing",
        "A reservation cannot have more than 20 passengers.": "A reservation cannot have more than 20 passengers.",
        "Paste MRZ here...": "Paste MRZ here...",
        "Previous": "Previous",
        "Page": "Page",
        "of": "of",
        "Next": "Next",
        "Add": "Add",
        "MRZ": "MRZ",
        "Total Records": "Total Records",
        "Manual": "Manual",
        "Save Changes BGR": "Save",
        "Save as Draft": "Save as Draft",
        "Submit BGR": "Submit",
        "Create Bus Reservation": "Create Bus Reservation",
        "Edit Bus Reservation": "Edit Bus Reservation",
        "Reservation Details": "Reservation Details",
        "PCS Reservation": "PCS Reservation",
        "Passenger/Vehicle Manifest": "Passenger Details:",
        "Type": "Type",
        "Action": "Action",
        "Remove": "Remove",
        "No manifest details added": "No manifest details added",
        "Add New Entry": "Add",
        "Name": "Name",
        "Passport Number": "Passport Number",
        "Passport Expiry Date": "Passport Expiry Date",
        "Reservation ID": "Reservation ID",
        "License Plate": "License Plate",
        "Transport Company": "Transport Company",
        "Select Company": "Select Company",
        "Status": "Status",
        "Select Status": "Select Status",
        "Travel Date": "Travel Date & Time",
        "Creation Date": "Creation Date & Time",
        "Search BGR": "Search BGR",
        "Create BGR": "Create BGR",
        "View": "View",
        "Edit": "Edit",
        "Edit (1 Time)": "Edit (1 Time)",
        "Submit": "Submit",
        "Unsubmit": "Unsubmit",
        "Close": "Close",
        "Export": "Export",
        "Reject": "Reject",
        "No BGR Lists Found": "No Bus Group Reservation Lists Found",
        "Actions": "Actions",
        "Bus Reservations": "Bus Reservations",
        "Go Back": "Go Back",
        "Print": "Print",
        "Print Thermal Ticket": "Print Thermal Ticket",
        "Change Printer": "Change Printer",
        "Printer Settings": "Printer Settings",
        "Select a printer": "Select a printer",
        "Save Changes": "Save Changes",
        "Print Test": "Print Test",
        "Print Boarding Card": "Print Boarding Card",
        "Download Boarding Card Pdf": "Download Boarding Card Pdf",
        "Download": "Download",
        "Cancelled": "Cancelled",
        "All": "All",
        "Confirmation": "Confirmation",
        "Boarding": "Boarding",
        'Cannot issue boarding pass. Confirmation status is "C"': 'Cannot issue boarding pass. Confirmation status is "C"',
        "Cannot issue boarding pass for an already printed ticket": "Cannot issue boarding pass for an already printed ticket",
        "You have successfully deleted this reservation.": "You have successfully deleted this reservation.",
        "You have successfully locked the selected trip.": "You have successfully locked the selected trip.",
        "You have successfully cancelled your boarding passes.": "You have successfully cancelled your boarding passes.",
        "Confirmation Passes Error": "There has been an error while issuing your confirmation passes. Please contact TMPA Support.",
        "You have successfully changed the trip of your tickets.": "You have successfully changed the trip for your tickets.",
        "Invalid Surname / Plates": "Invalid Surname / Plates",
        "Confirm Ticket Error": "There has been an error while confirming your tickets.",
        "You have successfully cancelled your tickets.": "You have successfully cancelled your tickets.",
        "You have successfully confirmed your tickets.": "You have successfully confirmed your tickets.",
        "Your Confirmation Passes have been issued.": "Your Confirmation Passes have been issued.",
        "Your Boarding Passes have been issued.": "Your Boarding Passes have been issued.",
        "Confirm Open Tickets": "Confirm Open Tickets",
        "Confirm Open Tickets And Issue Boarding Cards": "Confirm Open Tickets And Issue Boarding Cards",
        "Cancel": "Cancel",
        "Change Trip": "Change Trip",
        "Boarding Passes Error": "There has been an error while issuing your boarding passes. Please contact TMPA Support.",
        "Boarding Passes Issued": "Your Boarding Passes have been issued.",
        "No Data": "There are no reservation data for your search.",
        "Please type in or select a company": "Please type in or select a company",
        "Please type in the reservation number": "Please type in the reservation number",
        "Please type in a ticket number.": "Please type in a ticket or reservation number.",
        "Please select an itinerary.": "Please select an itinerary.",
        "Network Error": "Network Error. Please try again.",
        "Email Address": "Email Address",
        "Phone Number": "Phone Number",
        "Old Password": "Old Password",
        "New Password": "New Password",
        "Confirm New Password": "Confirm New Password",
        "Change Password": "Change Password",
        "Home": "Home",
        "Edit Ticket": "Edit Ticket",
        "Plate Number": " Plate Number",
        "Passport / Plates": "Passport / Plates",
        "Tanger Port Authority": "Tanger Port Authority",
        "User Id": "User Group:",
        "User Name": "User Name:",
        "User": "User",
        "Password": "Password:",
        "To": "To",
        "Login": "Login",
        "Logout": "Logout",
        "Signup": "Signup",
        "Language": "Language:",
        "English": "EN",
        "Spanish": "ES",
        "French": "FR",
        "Greek": "GR",
        "Date": "Date",
        "Company": "Company",
        "Filter by:": "Filter Itineraries by Company:",
        "Select Itinerary": "Select Itinerary",
        "Select Tickets": "Select Tickets",
        "Vessel": "Vessel",
        "Arrival Port": "Arrival Port",
        "Departure": "Departure",
        "Time": "Time",
        "Arrival": "Arrival",
        "Departure Date": "Departure Date",
        "Search for Reservation or Ticket by:": "Search for Reservation or Ticket by:",
        "PNR": "Reservation Number",
        "Surname": "Surname",
        "E-mail": "E-mail",
        "Search Reservation": "Search Reservation",
        "Ticket Number": "Ticket Number",
        "Surname Name": "Passenger Name",
        "Passenger Type": "Passenger Type",
        "Nationality": "Nationality",
        "Accomodation": "Accomodation",
        "Age/Cat Gender": "Age/Cat Gender",
        "Birth Date - Place": "Birth Date - Place",
        "Passport": "Passport",
        "Not Supported": "Not Supported",
        "Select Language": "Select Language",
        "No itinerary found for the selected date": "No itinerary found for the selected date",
        "Itinerary search": "Itinerary search",
        "Departure Itinerary": "Departure itinerary",
        "Return Itinerary": "Return itinerary",
        "Route analysis": "Route analysis",
        "Events": "Events",
        "Event": "Event",
        "Visit Event Site": "Visit Event Site",
        "Contact us": "Contact us",
        "Terms of use": "Terms of use",
        "Follow us": "Follow us",
        "No return trip selected": "No return trip selected",
        "No trips found": "No trips found for this date. Please select another date.",
        "Select": "Select",
        "Issue Boarding Cards": "Issue Boarding Cards",
        "Manual Entry": "Manual Entry",
        "Passenger": "Passenger",
        "Vehicle": "Vehicle",
        "Search Ticket": "Search Ticket",
        "firstName": "Name",
        "Maiden Name": "Maiden Name",
        "Age/Cat": "Age/Cat",
        "Adult": "Adult",
        "Child": "Child",
        "Infant": "Infant",
        "Gender": "Gender",
        "Male": "Male",
        "Female": "Female",
        "Birth Date": "Birth Date",
        "Birth Place": "Birth Place",
        "Occupation": "Occupation",
        "Coming From": "Coming From",
        "Going To": "Going To",
        "Residence Country": "Residence Country",
        "Address in Morocco": "Address in Morocco",
        "Phone During Stay": "Phone During Stay",
        "Visit Reason": "Visit Reason",
        "Accomodation Type": "Accomodation Type",
        "Cabin/Seat Number": "Cabin/Seat Number",
        "Berth": "Berth",
        "Special Service Req.": "Special Service Req.",
        "Document Type": "Document Type",
        "Travel Doc. Number": "Travel Doc. Number",
        "Travel Doc. Issue Date": "Travel Doc. Issue Date",
        "Visa Number": "Visa Number",
        "Identity ID": "Identity ID",
        "Dni": "Dni",
        "Special Passport": "Special Passport",
        "UN Travel Document": "UN Travel Document",
        "YES": "YES",
        "NO": "NO",
        "GENP": "GENP",
        "Vehicle Type": "Vehicle Type",
        "General Veh": "General Veh",
        "Registration Plates": "Registration Plates",
        "Driver Name": "Driver Name",
        "Length (cm)": "Length (cm)",
        "Height (cm)": "Height (cm)",
        "Connect Serial Device": "Connect Serial Device",
        "Model": "Model",
        "Brand": "Brand",
        "Plates": "Plates",
        "Length/Height": "Length/Height",
        "Issue Date": "Issue Date",
        "Expiration Date": "Expiration Date",
        "MRZ scanning is required. Please parse MRZ for the selected passengers.": "La lecture de la MRZ est obligatoire. Veuillez scanner la MRZ des passagers sélectionnés."
    },
}


// WEBPACK FOOTER //
// ./src/containers/assets/translations.js